import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

/**
 * Loads UI translation files from `src/assets/i18n`.
 *
 * `path` is the active language for root translations (`en`) and
 * `<scope>/<language>` for feature scopes (`dashboard/en`), so both resolve to
 * the same folder layout:
 *
 *   assets/i18n/en.json              -> app shell + shared components
 *   assets/i18n/dashboard/en.json    -> the dashboard feature
 *
 * Asset requests are not touched by the AuthInterceptor (it only augments API
 * calls) and Firebase Hosting serves them no-cache, so no cache busting here.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {

  constructor(private readonly http: HttpClient) { }

  getTranslation(path: string): Observable<Translation> {
    return this.http.get<Translation>(`/assets/i18n/${path}.json`);
  }
}
